<section class="content">
  <div class="card" style="padding: 25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" (ngModelChange)="changeEvent()" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" (ngModelChange)="changeEvent()" class="main-border-class" [min]="from_date" />
      </div>
      <div class="col-3">
        <mat-label>Selecte Product</mat-label>
        <mat-select [(ngModel)]="selected_product_option" (ngModelChange)="changeEvent()" class="main-border-class">
          <mat-option value="milk">Milk</mat-option>
          <mat-option value="curd">Curd</mat-option>
          <mat-option value="buttermilk">Butter Milk</mat-option>
        </mat-select>
      </div>
    </div><br>
    <hr style="background: white;">
    <span *ngIf="show_selection">
      <div class="row">
        <div class="col">
          <mat-radio-group aria-label="Select an option" (ngModelChange)="changeEvent()" [(ngModel)]="seleted_option_type">
            <div class="row">
              <div class="col-8">
                <mat-radio-button value="by_business_type" checked><label style="font-size: 20px;">By Institution
                    Type</label></mat-radio-button>
                <mat-radio-button value="by_business" style="padding-left: 38px;"><label style="font-size: 20px;">By Booth
                    Number</label></mat-radio-button>
              </div>
              <div class="col-4"></div>
            </div>
          </mat-radio-group>
        </div>
      </div><br>
      <div class="row">
        <div class="col-3" *ngIf="seleted_option_type == 'by_business'">
          <input type="text" style="border: 1px solid;border-radius: 14px;padding: 10px;"
            [(ngModel)]="entered_booth_number" (ngModelChange)="changeEvent()" /><br>
          <label style="color: red;">*Comma seperated booth number</label>
        </div>
      </div>
      <div class="row" *ngIf="seleted_option_type == 'by_business_type'">
        <div class="col-2">
          <mat-checkbox (change)="businessTypeOptionChanged($event, 'private_institute')">Private Institute</mat-checkbox>
        </div>
        <div class="col-2">
          <mat-checkbox (change)="businessTypeOptionChanged($event, 'govt_institute')">Govt Institute</mat-checkbox>
        </div>
        <div class="col-2">
          <mat-checkbox (change)="businessTypeOptionChanged($event, 'union_parlour')">Union Parlour</mat-checkbox>
        </div>
        <div class="col-2">
          <mat-checkbox (change)="businessTypeOptionChanged($event, 'society')">Society</mat-checkbox>
        </div>
      </div><br>
      <div class="row" *ngIf="seleted_option_type == 'by_business_type'">
        <div class="col-2">
          <mat-checkbox (change)="businessTypeOptionChanged($event, 'union_booth')">Union Booth</mat-checkbox>
        </div>
        <div class="col-2">
          <mat-checkbox (change)="businessTypeOptionChanged($event, 'nilgris')">Nilgris</mat-checkbox>
        </div>
        <div class="col-2">
          <mat-checkbox (change)="businessTypeOptionChanged($event, 'tirupur')">Tirupur</mat-checkbox>
        </div>
      </div>
      <hr style="background: white;">
    </span>

    <div class="row">
      <div class="col-2">
        <button (click)="getClicked()" style="font-size: 27px;border-radius: 5px;background: blanchedalmond;"
          [disabled]="to_date == null || from_date == null || selected_product_option == null">Get</button>
      </div>
      <div *ngIf="!is_document_available" class="col-2">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>
      <div class="col-2" *ngIf="document_file!== null">
        <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
            picture_as_pdf
          </i> Download report</button>
      </div>
    </div>
    <!-- <div class="row" *ngIf="document_file!== null">
      <div class="col-6"></div>
      <div class="col-6">
        <div class="row">
          <div class="col-4">
          </div>

          <div class="col-4">
            <button mat-button class="button-class"><i class="material-icons">
                get_app
              </i> Download Excel</button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</section>
